import React, {useEffect, useState} from 'react';
import {message, Modal, Upload} from 'antd';
import {ExportInfoDto, ExportTestControllerApi} from "../../api";
import {useKeycloakHeader} from "../../config/Config";
import {downloadFile} from "../../utils/FileDownload";

const ExportTestModal = ({visible, onClose}) => {

    const [exportInfo, setExportInfo] = useState<ExportInfoDto | null>(null);
    const headers = useKeycloakHeader();

    const exportTestControllerApi = new ExportTestControllerApi();


    useEffect(() => {
        exportTestControllerApi.getExportInfo(headers).then((response) => {
            let exportInfoDto = response.data;
            setExportInfo(exportInfoDto);
        }).catch((error) => {
            message.error("Es ist ein Fehler beim Anfragen von Exportinformationen aufgetreten. Dies könnte den Export beeinträchtigen!")
        })
    }, [visible]);

    const handleConfirm = () => {
        exportTestControllerApi.exportAllTests(headers)
            .then(response => {
                downloadFile(response.data, "exported_tests", "json");
                message.success("Datei erfolgreich heruntergeladen!");
                onClose();
            })
            .catch(error => {
                message.error("Fehler beim Herunterladen einer Datei! " + error.response.data, 15);
            });
    }


    return (
        <>
            <Modal open={visible} onCancel={onClose} onOk={handleConfirm} title="Exportiere alle Daten" width={800}
                   okText="Bestätigen"
                   cancelText="Abbrechen">
                {exportInfo ?
                    (<p>
                        Möchtest
                        du <b>{exportInfo.testAmount}</b> Tests, <b>{exportInfo.prefabAmount}</b> Komponenten, <b>{exportInfo.systemAmount}</b> Systeme
                        und <b>{exportInfo.passwordAmount}</b> Passwörter exportieren?
                    </p>)
                    : (<p>Keine Daten für den Export gefunden!</p>)}
            </Modal>
        </>
    );
};

export default ExportTestModal;
